<script lang="ts" setup>
import logo from '@/layouts/assets/cypress-logo.svg'
</script>

<template>
  <a class="relative z-30 flex-shrink-0 flex-grow sm:mr-[20px]" href="/" aria-label="Cypress">
    <img :src="logo?.src" width="80" height="32" alt="Cypress Logo" />
  </a>
</template>
